// extracted by mini-css-extract-plugin
module.exports = {"mapStill":"CatchMap_mapStill__YQEfw","mapFooter":"CatchMap_mapFooter__E1CKn"};